import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithData } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }
    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        loginWithData(data.token, data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard");
      } catch (e) {
        setError("Falha ao autenticar com Google.");
        setTimeout(() => navigate("/login"), 1500);
      }
    })();
  }, [navigate, loginWithData]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#fafaf8]">
      <Loader2 className="w-8 h-8 animate-spin text-[#1b5e3f]" />
      <p className="mt-4 text-[#78716c]">{error || "Entrando..."}</p>
    </div>
  );
}
